export default function({ state, commit, dispatch }, filter) {
    commit('startEditingFilter')

    return dispatch('patch', {
        url: '/provider/' + state.id + '/filter/' + filter.id,
        data: filter
    }, {
        root: true
    })
    .then((response) => {
        commit('finishEditingFilter')
        commit('addFilter', response)
		return response
    })
    .catch((error) => {
        commit('finishEditingFilter')
		throw error
    })
}
